
export class PossessedStatics {

    public static LOW_SYMBOLS:string[] = ["L1", "L2", "L3", "L4"];
    public static MID_SYMBOLS:string[] = ["M1", "M2", "M3", "M4"];
    public static SCATTER_SYMBOLS:string[] = ["S"];

    public static SYMBOL_SPRITE_WIDTH:number = 144;
    public static SYMBOL_SPRITE_HEIGHT:number = 148;

    public static SYMBOL_WIDTH:number = 144;
    public static SYMBOL_HEIGHT:number = 99;

    public static NUMBER_OF_REELS:number    = 5;
    public static NUMBER_OF_ROWS:number[]   = [3, 6, 6, 6, 3];

    public static REEL_X_OFFSET:number = PossessedStatics.SYMBOL_WIDTH;
    public static REEL_Y_OFFSET:number = PossessedStatics.SYMBOL_HEIGHT;

    public static STEP_WIDTH:number = PossessedStatics.SYMBOL_WIDTH * 0.5;
    public static STEP_HEIGHT:number = PossessedStatics.SYMBOL_HEIGHT * 0.5;

    public static REEL_AREA_X_OFFSET:number = 114;
    public static REEL_AREA_Y_OFFSET:number = 114;

    // Reel spin

    public static spinStartOffset:number = 0.2;

    public static spinStepDuration:number = 0.032;
    public static reelStopDelay:number = 0.40;
    public static reelStopDelayFastSpin:number = 0.15;

    constructor() {

    }

}


